import React from 'react';

import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { IBVControl } from '../../../models/BVControls/IBVControl';

import './bv-input-search.scss';

import BVControl from '../BVControl/bv-control';

interface IBVInputSearch extends IBVControl {
    properties: any;
}

const BVInputSearch: React.FunctionComponent<IBVInputSearch> = ({ className, errorMessage, infoMessage, label, properties, required }) => (
    <BVControl className={`bv-input-search ${className}`} errorMessage={errorMessage} infoMessage={infoMessage} label={label} required={required}>
        <Input {...properties} suffix={<SearchOutlined />} />
    </BVControl>
);

export default BVInputSearch;